import { Button, Modal } from "react-bootstrap";
interface PropData {
    show: boolean;
    setShow: (flag: boolean) => void,
    heading?: string,
    message?: string,
    acceptButtonText?: string,
    rejectButtonText?: string,
    handleYesClick: () => void
}
const ConfirmationModal = ({ show, acceptButtonText, rejectButtonText, setShow, heading = "Confirmation", message = "Are you sure , you want to delete?", handleYesClick }: PropData) => {
    return (<Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={() => setShow(false)}
    >
        <Modal.Header closeButton className="pb-2 border-bottom-1">
            <h4 className="font-24 ">{heading}</h4>
        </Modal.Header>

        <Modal.Body className="pt-0 text-center">
            <div className="mb-4 text-center">
                <p className="mb-0">{message}</p>
            </div>
            <div className="d-flex justify-content-center gap-2">
                <Button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: "120px" }}
                    onClick={() => setShow(false)}
                >
                    {rejectButtonText ? rejectButtonText : "No"}
                </Button>

                <Button
                    variant="danger px-3 p-2 text-nowrap"
                    style={{ width: "120px" }}
                    id="deleteBtnModal"
                    onClick={handleYesClick}
                >
                    {acceptButtonText ? acceptButtonText : "Yes"}
                </Button>
            </div>
        </Modal.Body>
    </Modal>)
}

export default ConfirmationModal;